import api from './baseApi';

export const login = async (credentials: Credentials) => {
  const response = await api.post('/auth/login', credentials);
  return response;
};
